// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__2R0er","left":"StickyBox_left__3c_cy","right":"StickyBox_right__CiBEr"};